/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import PasswordResetImg from '../../images/lock.svg';
import DefaultHome from '../../images/DEFAULT_HOME.svg';
import SingaporeHome from '../../images/SINGAPORE_HOME.svg';
import config from '../../config';
import './passwordResetRedirect.scss';

export const PasswordResetRedirect = () => {
  const handleRedirect = (url: string) => {
    return window.location.href = url;
  };

  return (
    <div className='password-redirect__container d-flex flex-md-row flex-column mb-4'>
      <div className='section col-12 col-md-8'>
        <div>
          <h1 className='mt-3 mb-4'>
            Success!
            <br />
            Your password has been reset.
          </h1>
          <p className='mb-4'>
            Now please click a tile below to go to your platform to log in. If there are any issues, or things look odd
            - please contact us using the chat bot below.
          </p>
        </div>
        <div className='d-flex'>
          <div
            className='hp-card-logo p-3 mr-4'
            onClick={() => handleRedirect(config.platform.international)}
          >
            <img src={DefaultHome} alt={'International'} width='80' height='120' />
            <div className='typographyLabelRegular'>International</div>
          </div>
          <div
            className='hp-card-logo p-3'
            onClick={() => handleRedirect(config.platform.singapore)}
          >
            <img src={SingaporeHome} alt={'Singapore'} width='80' height='120' />
            <div className='typographyLabelRegular'>Singapore</div>
          </div>
        </div>
      </div>
      <div className='section logo__wrapper col-12 col-md-4'>
        <img draggable={false} className='mt-4' src={PasswordResetImg} alt='G17Eco' />
      </div>
    </div>
  );
};
